export const Permission = {
  PROJECT_VIEW : "PROJECT_VIEW",
  PROJECT_CREATE : "PROJECT_CREATE",
  PROJECT_EDIT : "PROJECT_EDIT",
  PROJECT_EDIT_ASSIGNED : "PROJECT_EDIT_ASSIGNED",
  PROJECT_DELETE : "PROJECT_DELETE",
  REVIEW_VIEW : "REVIEW_VIEW",
  REVIEW_EDIT : "REVIEW_EDIT",
  REVIEW_EDIT_ASSIGNED : "REVIEW_EDIT_ASSIGNED",
  REVIEW_CREATE : "REVIEW_CREATE",
  RISK_UPLOAD : "RISK_UPLOAD",
  SETTINGS_EDIT :  "SETTINGS_EDIT",
  USER_APPROVAL : "USER_APPROVAL",
}
